import { LabReportTemplate } from './types';
import { standardLabReportTemplate } from './standardLabReport';
import { diodeCharacteristicsLabReportTemplate } from './diodeCharacteristicsLabReport';
import { halfWaveRectifierLabReportTemplate } from './halfWaveRectifierLabReport';
import { zenerDiodeLabReportTemplate } from './zenerDiodeLabReport';

export * from './types';
export * from './standardLabReport';
export * from './diodeCharacteristicsLabReport';
export * from './halfWaveRectifierLabReport';
export * from './zenerDiodeLabReport';

export const LAB_REPORT_TEMPLATES: LabReportTemplate[] = [
  diodeCharacteristicsLabReportTemplate,
  halfWaveRectifierLabReportTemplate,
  zenerDiodeLabReportTemplate,
  standardLabReportTemplate,
];

export const getLabReportTemplateById = (id: string): LabReportTemplate | undefined => {
  return LAB_REPORT_TEMPLATES.find((tpl) => tpl.id === id) || diodeCharacteristicsLabReportTemplate;
};
